import React from "react";
import { toast } from "react-toastify";

const ReactToast = ({ type, title, body }) => {
  const Msg = ({ title, content }) => (
    <div className="text-left">
      <h6 className="mb-0 react-toast-title">{title}</h6>
      <p className="mb-0 react-toast-body">{content}</p>
    </div>
  );
  {
    /* <Msg title="sedhal" content="Please read my message" /> */
  }
  const showToast = () => {
    switch (type) {
      case "success":
        toast.success(<Msg title={title} content={body} />);
        break;
      case "error":
        toast.error(<Msg title={title} content={body} />);
        break;
      case "warning":
        toast.error(<Msg title={title} content={body} />);
        break;
      // You can add more cases for other types like info, warning, etc.
      default:
        toast(body, { title });
    }
  };
  return showToast();
};

export default ReactToast;
